import * as types from '../actions/actionTypes';
import initialState from './initialState';
import indexOf from 'lodash/indexOf';
import pull from 'lodash/pull';

export default function accountReducer(state = initialState.accountState, action) {
    let activeProfile;
    let activeProfileID = state.activeProfileID;
    let enabledProfiles;
    let user;

    switch(action.type) {
        case types.LOGIN_SUCCESS:
        {
            const { access_token, userName } = action.payload;  
            const expires = action.payload['.expires'];  
            //if we confirmed this email before logging in, we can assume it's a new signup        
            return {
                ...state,
                token: access_token,
                tokenExpiry: expires,
                newSignup: state.emailConfirmed === userName
            };
        }
        case types.GET_USER_SUCCESS:
            user = action.user;
            //activeProfileID = localStorage.getItem('activeProfileID');
            enabledProfiles = user.Profiles.filter(p => p.Enabled);
            if(activeProfileID) {
                //we saved an activeProfileID before, try to find the profile and set it
                for(let i = 0; i < enabledProfiles.length; i++) {
                    if(enabledProfiles[i].ID == activeProfileID) {
                        activeProfile = enabledProfiles[i];
                        break;
                    }
                }
            }
            if(!activeProfile && enabledProfiles.length > 0) {
                //default the active role to the 1st role
                activeProfile = enabledProfiles[0];
                activeProfileID  = activeProfile.ID;
            }            
            if(activeProfile) {         
                user.activeProfile = activeProfile; 
                user.enabledProfiles = enabledProfiles;
            }     
            else {
                user.enabledProfiles = [];
            }      
            return {
                ...state,
                activeProfileID,
                user
            };            
        case types.SIGNUP_SUCCESS:
        {         
            return {
                ...state,
                newSignup: true
            };
        }
        case types.CONFIRM_EMAIL:           
            return {
                ...state,
                emailConfirmed: action.email
            };
        case types.UPDATE_ACTIVE_PROFILE:
            enabledProfiles = state.user.enabledProfiles;
            if(action.id) {      
                activeProfileID = action.id;          
                for(let i = 0; i < enabledProfiles.length; i++) {
                    if(enabledProfiles[i].ID == action.id) {
                        activeProfile = enabledProfiles[i];
                        break;
                    }
                }
            }
            user = {...state.user};
            if(activeProfile) {        
                user.activeProfile = activeProfile; 
            }       
            return {
                ...state,
                user: user,
                activeProfileID
            }
        case types.GET_NOTIFICATION_COUNT:
            {
                const { profileID, UnreadEmailCount, UnreadNotificationCount } = action.payload;  
                if(state.user && state.user.activeProfile && state.user.activeProfile.ID === profileID) {
                    user = {...state.user};
                    const activeProfile = { ...state.user.activeProfile, UnreadEmailCount, UnreadNotificationCount };                    
                    user.activeProfile = activeProfile; 
                    return {
                        ...state,
                        user
                    };
                }
                return state;
            }
        case types.PROFILE_IMAGES_UPDATED:
            {
                //the user has updated their images, update the featured image on the matching profile
                const profileID = action.profile.id;
                const featuredImage = action.profile.images.find(i => i.Featured);
                const user = state.user;
                if(featuredImage) {
                    return {
                        ...state,
                        user: {
                            ...user, 
                            Profiles: user.Profiles.map(profile => {
                                if(profile.ID === profileID) {
                                    return {...profile, DefaultImage: featuredImage.Path}
                                }
                                else {
                                    return profile;
                                }
                            }),
                            enabledProfiles: user.enabledProfiles.map(profile => {
                                if(profile.ID === profileID) {
                                    return {...profile, DefaultImage: featuredImage.Path}
                                }
                                else {
                                    return profile;
                                }
                            }),
                            activeProfile: user.activeProfile && user.activeProfile.ID === profileID ? 
                                {...user.activeProfile, DefaultImage: featuredImage.Path}
                                : 
                                user.activeProfile
                        }
                    }
                }
                else {
                    return {
                        ...state
                    };
                }
            }
        case types.ADD_CONNECTION:
            {
                const user = state.user;
                const plugUsername = action.connection.plugUsername;
                const socketProfileID = action.connection.socketProfileID;
                return {
                    ...state,
                    user: {
                        ...user, 
                        Profiles: user.Profiles.map(profile => {
                            if(profile.Username === plugUsername) {
                                return {...profile, OutboundConnections: [...profile.OutboundConnections, socketProfileID]}
                            }
                            else {
                                return profile;
                            }
                        }),
                        enabledProfiles: user.enabledProfiles.map(profile => {
                            if(profile.Username === plugUsername) {
                                return {...profile, OutboundConnections: [...profile.OutboundConnections, socketProfileID]}
                            }
                            else {
                                return profile;
                            }
                        }),
                        activeProfile: user.activeProfile && user.activeProfile.Username === plugUsername ? 
                            {...user.activeProfile, OutboundConnections: [...user.activeProfile.OutboundConnections, socketProfileID]}
                            : 
                            user.activeProfile
                    }
                }
            }
            case types.DELETE_CONNECTION:
            {
                const user = state.user;
                const plugUsername = action.connection.plugUsername;
                const socketProfileID = action.connection.socketProfileID;
                return {
                    ...state,
                    user: {
                        ...user, 
                        Profiles: user.Profiles.map(profile => {
                            if(profile.Username === plugUsername) {
                                return {...profile, OutboundConnections: profile.OutboundConnections.filter(c => c !== socketProfileID)}
                            }
                            else {
                                return profile;
                            }
                        }),
                        enabledProfiles: user.enabledProfiles.map(profile => {
                            if(profile.Username === plugUsername) {
                                return {...profile, OutboundConnections: profile.OutboundConnections.filter(c => c !== socketProfileID)}
                            }
                            else {
                                return profile;
                            }
                        }),
                        activeProfile: user.activeProfile && user.activeProfile.Username === plugUsername ? 
                            {...user.activeProfile, OutboundConnections: user.activeProfile.OutboundConnections.filter(c => c !== socketProfileID)}
                            : 
                            user.activeProfile
                    }
                }
            }
        case types.SET_LOGIN_ERROR:
            return {
                ...state,
                loginError: action.error.message
            }
        case types.CLEAR_LOGIN_ERROR:
            return {
                ...state,
                loginError: null
            }
        case types.SET_SIGNUP_ERROR:
            return {
                ...state,
                signupError: action.error.message
            }
        case types.CLEAR_SIGNUP_ERROR:
            return {
                ...state,
                signupError: null
            };    
        case types.SET_USER_LOADING:
                return {
                    ...state,
                    userLoading: true
                }
        case types.CLEAR_USER_LOADING:
            return {
                ...state,
                userLoading: false
            }
        case types.CREATE_PROFILE_SUCCESS: {
            const user =  {...state.user};
            user.Profiles = [...user.Profiles];
            user.Profiles.push(action.profile);
            if(action.profile.Enabled) {
                user.activeProfile = action.profile;
                user.enabledProfiles = [...user.enabledProfiles];
                user.enabledProfiles.push(action.profile);
            }
            return {
                ...state,
                user
            };
        }
        case types.UPDATE_PROFILE_SUCCESS: {
            const user =  {...state.user};
            user.Profiles = [...user.Profiles];
            const profile = user.Profiles.find(profile => profile.ID == action.profile.ID);            
            const existingProfileIndex = indexOf(user.Profiles, profile); 
            user.Profiles.splice(existingProfileIndex, 1, action.profile);
            if(user.activeProfile.ID === action.profile.ID) {
                user.activeProfile = action.profile;
            }
            user.enabledProfiles = user.Profiles.filter(p => p.Enabled);

            return {
                ...state,
                user
            };
        }
        case types.SOUNDCLOUD_LOGIN_SUCCESS:
                return {
                    ...state,
                    soundCloudToken: action.soundCloudToken
                }
        case types.UPDATE_TRACK_RATING: {
                const user =  {...state.user};
                let profile = user.Profiles.find(p => p.ID === action.trackRating.currentProfileID);
                if(profile) {
                    const profileIndex = user.Profiles.indexOf(profile);
                    user.Profiles = [...user.Profiles];
                    profile = {...profile};
                    profile.Ratings = [...profile.Ratings];
                    if(profile.Ratings.includes(action.trackRating.id)) {
                        pull(profile.Ratings, action.trackRating.id);
                    }   
                    else {
                        profile.Ratings.push(action.trackRating.id);
                    }   
                    user.Profiles[profileIndex] = profile;
                    if(user.activeProfile && user.activeProfile.ID === profile.ID) {
                        user.activeProfile = {...user.activeProfile};
                        user.activeProfile.Ratings = [...profile.Ratings];
                    }
                    user.enabledProfiles = user.enabledProfiles.map(p => {
                        if(p.ID === profile.ID) {
                            return {...p, Ratings: [...profile.Ratings]}
                        }
                        else {
                            return p;
                        }
                    });
                }
                return {
                    ...state,
                    user
                };
        }
        case types.UPDATE_VIDEO_RATING: {
            const user =  {...state.user};
            let profile = user.Profiles.find(p => p.ID === action.videoRating.currentProfileID);
            if(profile) {
                const profileIndex = user.Profiles.indexOf(profile);
                user.Profiles = [...user.Profiles];
                profile = {...profile};
                profile.Ratings = [...profile.Ratings];
                if(profile.Ratings.includes(action.videoRating.id)) {
                    pull(profile.Ratings, action.videoRating.id);
                }   
                else {
                    profile.Ratings.push(action.videoRating.id);
                }   
                user.Profiles[profileIndex] = profile;
                if(user.activeProfile && user.activeProfile.ID === profile.ID) {
                    user.activeProfile = {...user.activeProfile};
                    user.activeProfile.Ratings = [...profile.Ratings];
                }
                user.enabledProfiles = user.enabledProfiles.map(p => {
                    if(p.ID === profile.ID) {
                        return {...p, Ratings: [...profile.Ratings]}
                    }
                    else {
                        return p;
                    }
                });
            }
            return {
                ...state,
                user
            };
        }
        case types.LOGOUT:            
            return initialState.accountState;
        default:
            return state;
    }
}